<template>
  <div>
    <nav v-if="isMobileLayout" class="mobile-admin-navbar">
      <button
        class="mobile-nav-btn"
        type="button"
        @click="toggleSidebar"
        aria-label="Open menu"
      >
        <i class="fas fa-bars"></i>
      </button>

      <div class="mobile-nav-title">CLIENT</div>

      <div class="mobile-nav-right">
        <div
          v-if="!isVendor && (clientName || clientCode)"
          class="mobile-client-info"
        >
          <span v-if="clientName" class="mobile-client-name">{{ clientName }}</span>
          <span v-if="clientCode" class="mobile-client-id">{{ clientCode }}</span>
        </div>
        <notification-dropdown />
        <user-dropdown />
      </div>
    </nav>

    <nav
      v-else
      class="absolute top-0 left-0 w-full z-10 bg-transparent md:flex-row md:flex-nowrap md:justify-start flex items-center p-4"
    >
      <div
        class="w-full mx-autp items-center flex justify-between md:flex-nowrap flex-wrap md:px-10 px-4"
      >
        <a
          class="text-white text-sm uppercase hidden lg:inline-block font-semibold"
          href="javascript:void(0)"
        >
          Dashboard
        </a>

        <form
          class="md:flex hidden flex-row flex-wrap items-center lg:ml-auto mr-3"
        >
          <div
            v-if="!isVendor && (clientName || clientCode)"
            class="client-info-box"
          >
            <span v-if="clientName" class="client-info-name">{{ clientName }}</span>
            <span v-if="clientCode" class="client-info-id">Client ID: {{ clientCode }}</span>
          </div>
        </form>

        <ul class="flex-col md:flex-row list-none items-center flex">
          <user-dropdown />
        </ul>
      </div>
    </nav>
  </div>
</template>

<script>
import axios from "axios";
import UserDropdown from "@/components/Dropdowns/UserDropdown.vue";
import NotificationDropdown from "@/components/Dropdowns/NotificationDropdown.vue";

export default {
  components: {
    UserDropdown,
    NotificationDropdown,
  },
  data() {
    return {
      windowWidth: typeof window !== "undefined" ? window.innerWidth : 1440,
      clientName: "",
      clientCode: "",
    };
  },
  computed: {
    isMobileLayout() {
      return this.windowWidth < 1024;
    },
    isVendor() {
      return localStorage.getItem("user_type") === "vendor";
    },
  },
  methods: {
    toggleSidebar() {
      window.dispatchEvent(new CustomEvent("bfms-toggle-sidebar"));
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    async fetchClientProfile() {
      const token = localStorage.getItem("token");
      if (!token) return;

      try {
        const response = await axios.get(
          `${process.env.VUE_APP_BACKEND_DOMAIN}/api/fetch_client_information`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const client = response?.data?.client;
        if (client) {
          this.clientName = `${client.first_name || ""} ${client.last_name || ""}`.trim();
          this.clientCode = client.client_code || "";
        }
      } catch (error) {
        console.error("Failed to fetch client profile:", error);
      }
    },
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    if (!this.isVendor) {
      this.fetchClientProfile();
    }
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<style scoped>
.mobile-admin-navbar {
  position: sticky;
  top: 0;
  z-index: 40;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.9rem 1rem;
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.08);
}

.mobile-nav-btn {
  width: 46px;
  height: 46px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  color: #64748b;
  font-size: 1.25rem;
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.06);
}

.mobile-nav-title {
  font-size: 1.05rem;
  font-weight: 800;
  letter-spacing: 0.03em;
  color: #334155;
}

.mobile-nav-right {
  display: flex;
  align-items: center;
  gap: 0.35rem;
}

.mobile-client-info {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  line-height: 1.2;
  margin-right: 0.35rem;
  max-width: 140px;
}

.mobile-client-name {
  color: #334155;
  font-size: 0.75rem;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.mobile-client-id {
  color: #64748b;
  font-size: 0.68rem;
  font-weight: 500;
  white-space: nowrap;
}

.client-info-box {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  line-height: 1.25;
}

.client-info-name {
  color: #ffffff;
  font-size: 0.85rem;
  font-weight: 700;
  text-transform: uppercase;
}

.client-info-id {
  color: rgba(255, 255, 255, 0.85);
  font-size: 0.75rem;
  font-weight: 500;
}
</style>
